import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-col"},[_c('div',{staticClass:"input-cont"},[_c(VTextField,_vm._g({attrs:{"label":"Days","readonly":"","disabled":""},model:{value:(_vm.daysDiference),callback:function ($$v) {_vm.daysDiference=$$v},expression:"daysDiference"}},_vm.on))],1)])}
var staticRenderFns = []

export { render, staticRenderFns }